import React, { PropsWithChildren } from 'react';
import { DivProps } from '../../../types/HtmlProps';
import { appendClassNames } from '../../../lib/bemUtils/classname';
import { PreviewCaption } from './PreviewCaption';

export function ImageContainer({
  filename,
  children,
  className,
  ...rest
}: PropsWithChildren<DivProps & { filename?: string }>) {
  return (
    <figure className="image-upload__image-container">
      {filename && <PreviewCaption fileName={filename} />}
      <div className={appendClassNames(className, 'image-upload__file-image-container')} {...rest}>
        {children}
      </div>
    </figure>
  );
}
